import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@mantine/core';
import { Context as VendorContext } from '../../../providers/VendorContextProvider';
import AppStack from '../../common/AppStack';
import ResponsiveModal from '../../common/ResponsiveModal';
import AppText from '../../common/AppText';
import { triggerNotification } from '../../../helpers/notification';

const ExternalConnectionSetupModal = ({ isOpen, onClose, config }) => {
  const {
    state,
    fetchVendorSetupSummary,
    updateVendorExternalConnections
  } = useContext(VendorContext);
  const [formState, setFormState] = useState({
    fkEcomExternalConnectionType: null,
    isEnabled: false,
    loading: false
  });
  const ecomVendor = state.ecomVendorSetupSummary.value?.ecomVendor;
  const vendorExternalConnection = ecomVendor?.ecomVendorExternalConnections?.find(
    (f) =>
      f.fkEcomExternalConnectionType.toString() ===
      config?.pkEcomExternalConnectionType.toString()
  );

  useEffect(() => {
    if (isOpen) {
      setFormState({
        fkEcomExternalConnectionType: config?.pkEcomExternalConnectionType,
        isEnabled:
          vendorExternalConnection && !vendorExternalConnection.deleted,
        loading: false
      });
    }
  }, [isOpen]);

  return (
    <ResponsiveModal
      formSectionProps={{
        isLoading: formState.loading,
        isSubmitDisabled: !vendorExternalConnection && !formState.isEnabled,
        onCancel: onClose,
        onSubmit: () => {
          setFormState({ ...formState, loading: true });
          updateVendorExternalConnections(
            ecomVendor.pkEcomVendor,
            {
              ecomVendorExternalConnections: [
                {
                  fkEcomExternalConnectionType:
                    formState.fkEcomExternalConnectionType,
                  deleted: !formState.isEnabled
                }
              ]
            },
            () => {
              fetchVendorSetupSummary(ecomVendor.pkEcomVendor, {skipLoading: true});
              setFormState({ ...formState, loading: false });
              onClose();
            },
            (e) => {
              triggerNotification(e);
              setFormState({ ...formState, loading: false });
            }
          );
        },
        submitTitle: 'Save changes'
      }}
      isOpen={isOpen}
      onClose={onClose}
      title={`Configure ${config?.title}`}
    >
      <AppStack style={{ gap: 16 }}>
        <AppText style={{ fontSize: 14 }}>{config?.description}</AppText>

        <Switch
          checked={formState.isEnabled}
          disabled={formState.loading}
          label={`Enable ${config?.title}`}
          onChange={() => {
            setFormState({
              ...formState,
              isEnabled: !formState.isEnabled
            });
          }}
        />
      </AppStack>
    </ResponsiveModal>
  );
};

ExternalConnectionSetupModal.propTypes = {
  config: PropTypes.object,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default ExternalConnectionSetupModal;
